import { render, staticRenderFns } from "./AllCustomerListing.vue?vue&type=template&id=152582c5"
import script from "./AllCustomerListing.vue?vue&type=script&lang=js"
export * from "./AllCustomerListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports